module.exports = __webpack_public_path__ + "static/media/2021_composite.1d5a650a.jpg";